import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FeatureFlagService } from '../../../../../shared/services/feature-flag.service';
import { Answer } from '../../../../applicant-service/service-models/Answer';
import { TextQuestion } from '../../../../job-service/service-models/TextQuestion';
import { QuestionComponent } from '../question-component';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent extends QuestionComponent<TextQuestion> implements OnInit {
  @ViewChild('questionElement') questionElement: ElementRef;
  downloadRoute: string;
  
  constructor() {
    super();
  }
  
  ngOnInit() {
    this.question = this.question || new TextQuestion();

    if (this.question.answers === undefined) {
      const answer = new Answer();
      answer.questionId = this.question.id;
      answer.questionVersion = this.question.version;
      this.question.answers = [answer];
    }

    this.downloadRoute = `jobs/${this.jobId}/elements/${this.element.id}/questions/${this.question.id}/attachments`;

    setTimeout(() => this.resize(), 0);
  }

  private resize() {
    const textarea = this.questionElement.nativeElement as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
}
